var map = {
	"./doo-logo.svg": 8822,
	"./han-logo.svg": 4827,
	"./hyd-logo.svg": 8773,
	"./kia-logo.svg": 3559,
	"./kiw-logo.svg": 5309,
	"./kt-logo.svg": 7963,
	"./lg-logo.svg": 7641,
	"./lot-logo.svg": 1659,
	"./nc-logo.svg": 9207,
	"./sam-logo.svg": 3947,
	"./sm-logo.svg": 9420,
	"./ssg-logo.svg": 4055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7720;